import type { ConfidenceOptions } from '@spotify-confidence/sdk';

export const FLAG_RESOLVER_PROXY_BASE_URL = '/api/flag-resolver';

const PRODUCTION_HOSTS = ['app.confidence.spotify.com'];

type FlagResolverProxyOptions = Pick<
  ConfidenceOptions,
  'resolveBaseUrl' | 'applyBaseUrl'
>;

export const getFlagResolverProxyOptions = (
  hostname: string,
  origin: string,
): FlagResolverProxyOptions | Record<string, never> =>
  PRODUCTION_HOSTS.includes(hostname)
    ? {
        resolveBaseUrl: `${origin}${FLAG_RESOLVER_PROXY_BASE_URL}`,
        applyBaseUrl: `${origin}${FLAG_RESOLVER_PROXY_BASE_URL}`,
      }
    : {};
